import { IconMail, IconMailbox } from '@tabler/icons-react';
import { i18nKeys } from 'locales';

export type TemplateChannel = (typeof CHANNEL_CONFIGS)[number]['key'];
export type TemplateChannelConfig = (typeof CHANNEL_CONFIGS)[number];

export const CHANNEL_CONFIGS = [
  { key: 'email', labelKey: i18nKeys.EMAIL, Icon: IconMail },
  { key: 'letter', labelKey: i18nKeys.POST, Icon: IconMailbox },
] as const;

const EMAIL_ONLY_STEP_TYPES = ['invoice', 'credit_note'];

export const channelsForStepType = (stepType: string) =>
  EMAIL_ONLY_STEP_TYPES.includes(stepType)
    ? CHANNEL_CONFIGS.filter(({ key }) => key === 'email')
    : CHANNEL_CONFIGS;
